//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapMutations } from "vuex";
export default {
  name: "ADL",
  data() {
    return {
      form: {
        value1: "",
        value2: "",
        value3: "",
        value4: "",
        value5: "",
        value6: "",
      },
      hasScore: false,
      disabled: false,
      num: "",
      num1: "",
      dataList: [
        {
          value: "1",
          name: "无需帮助洗澡（如使用浴缸，则可以自己进出浴缸）;仅帮助单个部位清洗（如背部或腿部）",
        },
        { value: "0", name: "帮助身体多个部位洗澡；帮助进出浴缸；不洗澡" },
      ],
      dataList1: [
        {
          value: "1",
          name: "从衣橱拿取衣物、穿上衣物、扣扣子（不包括系鞋带）",
        },
        { value: "0", name: "需要帮助拿取衣物及穿衣" },
      ],
      dataList2: [
        {
          value: "1",
          name: "从衣橱拿取衣物、穿上衣物、扣扣子（不包括系鞋带）",
        },
        { value: "0", name: "需要帮助拿取衣物及穿衣" },
      ],
      dataList3: [
        {
          value: "1",
          name: "上下床或椅子时无需帮助（可以使用拐杖或助行器等支撑物）",
        },
        { value: "0", name: "上下床或椅子时需要帮助；卧床" },
      ],
      dataList4: [
        { value: "1", name: "完全自主控制" },
        {
          value: "0",
          name: "部分或完全失控；需要灌肠、导尿管或监督使用便池便盆",
        },
      ],
      dataList5: [
        { value: "1", name: "可以自主进食" },
        { value: "0", name: "需要协助喂养；肠外营养" },
      ],
    };
  },
  created() {
    this.hideLoad();
  },
  methods: {
    ...mapMutations(["hideLoad"]),
  },
  computed: {
    /** 计算公式结果 */
    score() {
      let self = this;
      let form = JSON.parse(JSON.stringify(self.form));
      let flag = true;
      let result  = 0
      for (const key in form) {
        if (form.hasOwnProperty(key)) {
          if (!form[key]) {
            flag = false;
          } else {
            if (form[key] == "---") {
              flag = false;
            } else {
              form[key] = Number(form[key]);
            }
            result += Number(form[key]);
          }
        }
      }
      if (!flag) {
        self.hasScore = false;
        return "--";
      } else {
        self.hasScore = true;
        console.log(result);
        return String(result);
      }
    },
  },
};



// WEBPACK FOOTER //
// ./src/pages/formulas/Common/ADL.vue